import {Route, Routes} from 'react-router-dom';
import './css/App.css';
import Main from "./bas/Main";
import Login from "./bas/Login";
import Chat from "./bas/Chat";

function App() {

    return (
        <>
            <div className="app-container">
                <div className="content-container">
                    <Routes>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/" element={<Main/>}/>
                        <Route path="/chat" element={<Chat/>}/>
                    </Routes>
                </div>
            </div>
        </>
    );
}

export default App;
